import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'
import { useAuth } from '@/hooks/useAuth'
import { HomePage } from '@/components/infoPages/HomePage'

const signupSearchSchema = z.object({
  token: z.string().optional(),
})

const SignupRouteComponent = () => {
  const { openSignupDialog } = useAuth()
  useEffect(() => {
    openSignupDialog()
  }, [openSignupDialog])
  return <HomePage />
}

export const Route = createFileRoute('/auth/signup')({
  validateSearch: signupSearchSchema,
  beforeLoad: ({ search }) => {
    if (search.token) {
      throw redirect({
        to: '/auth/invite',
        search: { token: search.token },
      })
    }
  },
  component: SignupRouteComponent,
})
